import type { GrowthBook } from '@growthbook/growthbook-react';
import type { ProtectionExperimentGroup } from 'checkout';

let sharedGrowthBook: GrowthBook | undefined;

export const shareGrowthBook = (growthBook: GrowthBook) => {
  sharedGrowthBook = growthBook;
};

export const getProtectionExperimentGroup = (
  growthBook: GrowthBook | undefined = sharedGrowthBook
): ProtectionExperimentGroup => {
  if (!growthBook?.isOn('feature.ecom2')) return 'not_assigned';
  const result = growthBook.evalFeature('feature.refund-protect').experimentResult;
  if (!result?.inExperiment) return 'not_assigned';
  if (result.value === true) return 'offer';
  if (result.value === false) return 'control';
  return 'not_assigned';
};
